// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialogTitle {
  border-bottom: 1px solid black;
  width: 100%;
}

.width100 {
  width: 100%;
}

.list {
  padding-top: 0;
}

.btn {
  margin-left: 10px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.modal-body {
  max-height: 70vh;
  overflow-y: scroll;
}

.address-w-45 {
  width: 45%;
}

.error {
  color: red;
  font-size: 12px;
}

.min-height {
  min-height: 2rem;
}

h5 {
  text-align: center;
  text-decoration: underline;
}

.postal-address-label {
  width: 30%;
}

.left-margin {
  margin-left: 268px;
}

.label-width, postal-address-label {
  min-width: 93px;
}

.postal-address-label {
  width: 10%;
}

.left-padding {
  margin-top: 1px;
}

.custom-control-label {
  margin-left: 30px;
  padding-top: 7px;
}

.custom-form {
  height: 100%;
}

.form-responsive {
  display: block;
  width: 100%;
}

label {
  margin-bottom: 0px;
}

.organisationForm {
  height: 80%;
}

.gray-out {
  background-color: lightgray !important;
}

.organisationFormContainer {
  margin-left: 5px;
  margin-right: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
